import(/* webpackMode: "eager", webpackExports: ["MiniAppWeb3Providers"] */ "/vercel/path0/src/app/utils/MiniAppWeb3Providers.tsx");
